// ======================================================================
// FILE: src/modules/wms/dashboard/components/PriorityDistributionCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Dynamic Priority Distribution
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";


// ======================================================================
// PRIORITY COLORS
// ======================================================================

const COLORS = [
  "#dc3545",
  "#fd7e14",
  "#0d6efd",
  "#198754",
];


// ======================================================================
// COMPONENT
// ======================================================================

export default function PriorityDistributionCard({
  data = [],
}) {


  // --------------------------------------------------------------------
  // Ensure chart receives an array.
  // --------------------------------------------------------------------

  const chartData = Array.isArray(data)
    ? data
    : [];


  // --------------------------------------------------------------------
  // Check whether there is actual data.
  // --------------------------------------------------------------------

  const hasData = chartData.some(
    item =>
      Number(item?.value || 0) > 0
  );


  return (

    <div className="card shadow-sm h-100">


      {/* ================================================================
          HEADER
          ================================================================ */}

      <div className="card-header bg-white">

        <h5 className="mb-0">
          Priority Distribution
        </h5>

      </div>


      {/* ================================================================
          BODY
          ================================================================ */}

      <div className="card-body">


        {!hasData ? (

          <div
            className="
              d-flex
              align-items-center
              justify-content-center
              text-muted
            "
            style={{
              height: "320px",
            }}
          >

            No work data available.

          </div>

        ) : (

          <ResponsiveContainer
            width="100%"
            height={320}
          >

            <PieChart>

              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                label
              >

                {chartData.map(
                  (entry, index) => (

                    <Cell
                      key={
                        `${entry?.name || "priority"}-${index}`
                      }
                      fill={
                        COLORS[
                          index % COLORS.length
                        ]
                      }
                    />

                  )
                )}

              </Pie>


              <Tooltip />


              <Legend />

            </PieChart>

          </ResponsiveContainer>

        )}

      </div>

    </div>

  );

}